import FederationTemplateConfig from "../template";
import { merge } from "lodash-es";
import Colors, { quillColors } from "./colors";
export default class FinnishFederation extends FederationTemplateConfig {
    constructor() {
        super();
        this.logo = {
            image: require("./logo.svg"),
            label: "KIPA",
            backgroundColor: "accent"
        };
        this.countryCode = "FI";
        this.locale = "fi-FI";
        this.sprites = require("./finland-sprites.svg");
        this.placeholderLogo = require("./placeholder-logo.png");
        this.webTitle = "KIPA";
        this.colors = merge(this.colors, Colors);
        this.quillColors = merge(this.quillColors, quillColors);
        this.heroBanner = {
            webp: require(`./banner.webp`),
            jpeg: require(`./banner.jpg`)
        };
        this.documents = {
            paymentTermsOfService: null
        };
        this.links = {
            homepage: "https://www.ratsastus.fi/",
            news: "https://www.ratsastus.fi/ajankohtaista/",
            rulesPage: null
        };
    }
}
